import { render } from "./ScoreSection.vue?vue&type=template&id=2670e368&scoped=true"
import script from "./ScoreSection.vue?vue&type=script&lang=js"
export * from "./ScoreSection.vue?vue&type=script&lang=js"

import "./ScoreSection.vue?vue&type=style&index=0&id=2670e368&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2670e368"]])

export default __exports__